'use client';

import { useEffect } from 'react';

export default function Favicon() {
    useEffect(() => {
        if (typeof document !== 'undefined') {
            const oldFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]');
            oldFavicons.forEach((link) => link.remove());

            // Adicionar timestamp para forçar atualização do cache
            const timestamp = new Date().getTime();

            // Adicionar novo favicon com cache busting
            const favicon = document.createElement('link');
            favicon.rel = 'icon';
            favicon.type = 'image/png';
            favicon.href = `/favicon.png?v=${timestamp}`;
            document.head.appendChild(favicon);

            // Adicionar shortcut icon também
            const shortcut = document.createElement('link');
            shortcut.rel = 'shortcut icon';
            shortcut.type = 'image/png';
            shortcut.href = `/favicon.png?v=${timestamp}`;
            document.head.appendChild(shortcut);

            // Adicionar apple-touch-icon
            const appleIcon = document.createElement('link');
            appleIcon.rel = 'apple-touch-icon';
            appleIcon.href = `/favicon.png?v=${timestamp}`;
            document.head.appendChild(appleIcon);
        }
    }, []);

    return null;
}

